/**
 * Created by r4zi4l on 04.06.2021
 */

const SpecialEnergyOfferWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this._super({
            name: "SpecialEnergyOfferWindow",
            content: this.createContent(),
            title: Messages.get("SpecialEnergyOfferWindow.title"),
            noBackground: true,
            closeButton: true,
            closeButtonDelay: true,
            notCloseByTouchInShadow: true,
            openSound: bundles.specialenergyofferwindow.urls.show_person_sfx
        });

        cleverapps.paymentsLogic.onChangeStatus(this.updateButton.bind(this), this);

        cleverapps.focusManager.showControlsWhileFocused(["MenuBarGoldItem", "MenuBarLivesItem"]);

        cleverapps.specialEnergyOffer.onPurchaseFinished = this.createListener((success) => {
            if (success) {
                this.close();
            } else {
                this.updateButton();
            }
        });
    },

    updateButton: function () {
        this.button.setString(cleverapps.specialEnergyOffer.getPriceTag());

        if (cleverapps.specialEnergyOffer.getProduct().isAvailable()) {
            this.button.enable();
        } else {
            this.button.disable();
        }
    },

    getPerson: function () {
        return cleverapps.styles.SpecialEnergyOfferWindow.person || cleverapps.persons.choose("jihn", "dwarf");
    },

    createContent: function () {
        const styles = cleverapps.styles.SpecialEnergyOfferWindow;

        const container = new cc.Node();
        container.setAnchorPoint(0.5, 0.5);
        container.setContentSize2(styles.animation);

        this.animation = new cleverapps.Spine(bundles.specialenergyofferwindow.jsons.energy_offer_json);
        const skin = !cleverapps.meta.getSelectedLocation().locationConfig.isMain ? "expedition" : "normal";
        if (this.animation.hasSkin(skin)) {
            this.animation.setSkin(skin);
        }
        container.addChild(this.animation);
        this.animation.setAlignment(styles.animation);
        this.animation.setAnimationAndIdleAfter("open", "idle");

        this.button = new cleverapps.UI.Button({
            text: cleverapps.specialEnergyOffer.getPriceTag(),
            width: styles.button.width,
            height: styles.button.height,
            onClicked: function () {
                cleverapps.specialEnergyOffer.buy();
                if (cleverapps.forces.isRunningForce()) {
                    cleverapps.forces.closeRunningForce();
                }
            }
        });

        this.updateButton();
        this.createTimer();

        this.createReward(container);

        return new cleverapps.Layout([container, this.timerBlock, this.button].filter(Boolean), {
            margin: styles.margin,
            direction: cleverapps.UI.VERTICAL
        });
    },

    createTimer: function () {
        const styles = cleverapps.styles.SpecialEnergyOfferWindow.timer;

        const timeLeft = cleverapps.specialEnergyOffer.getIconLeftTime();
        if (timeLeft <= 0) {
            return;
        }

        const text = cleverapps.UI.generateOnlyText(
            Messages.get("SpecialEnergyOfferWindow.timeLeft"),
            cleverapps.styles.FONTS.ENERGY_OFFER_TIMER
        );
        text.fitTo(styles.text.width);
        const timer = this.timer = new Timer(timeLeft, this.timeIsUp.bind(this));

        this.timerBlock = new cleverapps.Layout([text, timer], {
            margin: styles.margin,
            direction: cleverapps.UI.HORIZONTAL
        });
    },

    timeIsUp: function () {
        this.timerBlock.removeAllChildren();
    },

    createReward: function (container) {
        const sprite = cleverapps.skins.getSlot("energy_icon_0") || bundles.specialenergyofferwindow.frames.energy_icon_0;
        if (!sprite) {
            return;
        }

        const icon = new cc.Sprite(sprite);
        const txt = cleverapps.UI.generateImageText(`x${cleverapps.specialEnergyOffer.getEnergyAmount()}`, cleverapps.styles.FONTS.ENERGY_OFFER);

        const styles = cleverapps.styles.SpecialEnergyOfferWindow.reward;

        const node = this.rewardNode = new cleverapps.Layout([icon, txt], {
            direction: cleverapps.UI.HORIZONTAL
        });
        container.addChild(node);
        node.setAlignment(styles);
        node.setRotation(styles.rotation || 0);
    },

    onShow: function () {
        this._super();

        this.animation.setOpacity(0);
        this.animation.runAction(new cc.FadeIn(0.4));

        this.button.setScale(0);
        this.button.runAction(new cc.Sequence(
            new cc.DelayTime(0.15),
            new cc.ScaleTo(0.2, 1)
        ));
    },

    listBundles: function () {
        return ["specialenergyofferwindow"];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ENERGY_OFFER: {
        size: 60,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },
    ENERGY_OFFER_TIMER: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.SpecialEnergyOfferWindow = {
    margin: 30,

    button: {
        width: 300,
        height: 120
    },

    reward: {
        x: { align: "center" },
        y: { align: "center", dy: -284 }
    },

    animation: {
        width: 1200,
        height: 700,

        x: { align: "center" },
        y: { align: "center", dy: 100 }
    },

    timer: {
        margin: 20,

        text: {
            width: 500
        }
    }
};
